var exports = {
  "z": "x93eb46d8--c60574--root",
};

module.exports = exports;
